export class IConfig {
    value?: Date;
    mask?: boolean;
    format?: string;
    timepicker?: boolean;
    defaultSelect: string;
    maxDate?: string|number;
    onSelectDate?: Function;
    minDate?: string|number|Date;
    defaultDate?: string|boolean|Date;
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/jquery-date-picker/interfaces/config.ts